import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { showNotification } from "Common/utils/Notification";
import BreadCrumb from "Common/BreadCrumb";
import { SUB_CATEGORY_ADD_ROUTE, SUB_CATEGORY_LIST_ROUTE } from "constants/routeEnum";
import { ToastContainer } from "react-toastify";
import LoaderComponent from "Common/Components/Loader/Loader";
import SubCategory from "./SubCategory";

const AddSubCategory = () => {
  const navigate = useNavigate();
  const [buttons, setButtons] = useState<any>([]);
  const [loader, setLoader] = useState<any>(false);
  const [headerText, setHeaderText] = useState<any>();
  const [categories, setCategories] = useState<any[]>([]);
const [selectedCategory, setSelectedCategory] = useState<string>("");


  const [errors, setErrors] = useState<any>({
  banner_header_text: "",
  category: "",
});

const handleSave = async () => {
  const trimmedHeader = (headerText || "").trim();
  const trimmedCategory = (selectedCategory || "").trim();

  const newErrors = {
    banner_header_text: trimmedHeader === "" ? "Please enter sub category." : "",
    category: trimmedCategory === "" ? "Please select a category." : "",
  };

  setErrors(newErrors);

  const hasErrors = Object.values(newErrors).some((e) => e);
  if (hasErrors) return;

  try {
    setLoader(true);
    const res = await callApi(`v1/subcategory/new`, "post", {
      subcategory: {
        name: trimmedHeader,
        slug: _.kebabCase(trimmedHeader),
        category_slug: trimmedCategory,
      }
    });
    setLoader(false);
    if (res?.status === "Success") {
      showNotification("Subcategory added successfully!", "success");
      navigate(SUB_CATEGORY_LIST_ROUTE);
    } else {
      showNotification("Something went wrong. Please try again.", "error");
    }
  } catch (e) {
    showNotification("An error occurred. Please try again.", "error");
    setLoader(false);
  }
};



  useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await callApi("v1/category/list", "post", {
        pageNum: 1,
        pageSize: 100,
        filters: {},
      });

      if (res?.status === "Success") {
        setCategories(res.data.categoryList || []);
      }
    } catch (error) {
      showNotification("Failed to fetch categories", "error");
    }
  };

  fetchCategories();
}, []);


  return (
    <>
      <BreadCrumb
        title={SUB_CATEGORY_ADD_ROUTE}
        pageTitle={SUB_CATEGORY_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">

        <label className="inline-block mb-2 text-base font-medium">
  Select Category
</label>
<select
  className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500"
  value={selectedCategory}
  onChange={(e) => {
    setSelectedCategory(e.target.value);
    setErrors((prev) => ({ ...prev, category: "" }));
  }}
>
  <option value="">-- Select a Category --</option>
  {categories.map((cat) => (
    <option key={cat._id} value={cat.slug}>
      {cat.name}
    </option>
  ))}
</select>
{errors.category && (
  <p className="text-red-500">{errors.category}</p>
)}

            <label className="inline-block mb-2 text-base font-medium mt-4">
              Sub-Category
            </label>
            <input
              type="text"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter Sub Category Code"
              value={headerText}
              onChange={(e) => {
                setErrors((prev) => ({
                  ...prev,
                  ["banner_header_text"]: "",
                }));
                setHeaderText(e.target.value);
              }}
            />
            {errors.banner_header_text && (
              <p className="text-red-500">{errors.banner_header_text}</p>
            )}



            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => handleSave()}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? <LoaderComponent /> : " Save"}
              </button>

              <Link
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                to={SUB_CATEGORY_LIST_ROUTE}
              >
                cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSubCategory;
